import { Chip } from '@mui/material';
import { palette } from '../theme';

export type RunStatus = 'success' | 'partial' | 'failed';

const styles: Record<RunStatus, { bg: string; color: string; label: string }> = {
  success: { bg: palette.sage[100], color: palette.sage[700], label: 'Success' },
  partial: { bg: '#FEF3C7', color: '#92400E', label: 'Partial' },
  failed: { bg: '#FEE2E2', color: palette.coral[700], label: 'Failed' },
};

export function StatusChip({ status }: { status: RunStatus | string }) {
  const def = (status in styles ? styles[status as RunStatus] : { bg: '#E5E7EB', color: '#374151', label: status });
  return (
    <Chip
      size="small"
      label={def.label}
      sx={{ bgcolor: def.bg, color: def.color, fontWeight: 600, textTransform: 'capitalize' }}
    />
  );
}
